import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Custom Catering',
        content: 'Tailored catering services crafted to match your unique tastes and event needs.',
        paragraphs: [
            'Experience the epitome of culinary excellence with our custom catering services, tailored to meet your unique preferences and requirements. Whether it\'s an intimate gathering or a grand celebration, our team of expert chefs and event planners will ensure your event is unforgettable.',
            'Our custom catering offers a personalized approach to create a menu that reflects your taste and style. From exquisite appetizers to decadent desserts, every dish is crafted with the finest ingredients and meticulous attention to detail.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Personalized Menu Creation',
            'Exquisite Culinary Presentations',
            'Professional and Friendly Service',
            'Flexible Scheduling and Venues',
            'Special Dietary Accommodations'
        ],
        procedure: [
            'Initial Consultation and Planning',
            'Menu Design and Tasting Sessions',
            'Event Day Preparation and Setup',
            'Seamless Service and Culinary Excellence',
            'Post-Event Cleanup and Feedback'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of events do you cater?',
                content: 'We cater to a wide range of events, including weddings, corporate functions, private parties, and more. Our custom catering services are tailored to fit the specific needs and themes of your event.'
            },
            {
                id: 2,
                heading: 'Can you accommodate special dietary requirements?',
                content: 'Yes, we offer a variety of menu options that cater to special dietary requirements, including vegetarian, vegan, gluten-free, and more. We work closely with you to ensure all guests\' needs are met.'
            },
            {
                id: 3,
                heading: 'What is the process for booking your services?',
                content: 'The process starts with an initial consultation to discuss your event details and requirements. We then design a custom menu, arrange tasting sessions, and finalize the event plan to ensure everything is perfect for your special day.'
            },
            {
                id: 4,
                heading: 'Do you provide staff for the event?',
                content: 'Yes, our professional and friendly staff are available to provide seamless service throughout your event. From chefs and servers to bartenders and event coordinators, we ensure your event runs smoothly.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Event Planning',
        content: 'Expertly coordinated events tailored to your vision and occasion needs.',
        paragraphs: [
            'Our professional event planning services are designed to turn your vision into a seamless and memorable experience. Whether you’re organizing a wedding, corporate event, or private celebration, our dedicated planners manage every detail with precision and creativity.',
            'From concept development to execution, we ensure your event reflects your style and exceeds expectations. With personalized coordination, vendor management, and on-site supervision, we handle everything so you can enjoy your special occasion stress-free.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Personalized Event Concepts',
            'Venue and Vendor Coordination',
            'Creative Theme and Décor Planning',
            'Budget Management and Scheduling',
            'On-Site Supervision and Support'
        ],
        procedure: [
            'Initial Consultation and Concept Design',
            'Budgeting and Vendor Selection',
            'Theme Development and Detailing',
            'Pre-Event Coordination and Setup',
            'On-Day Management and Wrap-Up'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of events do you plan?',
                content: 'We plan a variety of events including weddings, corporate functions, social gatherings, birthdays, and more. Each event is customized to match your goals and expectations.'
            },
            {
                id: 2,
                heading: 'Do you handle vendor arrangements?',
                content: 'Yes, we coordinate with trusted vendors for venues, catering, décor, photography, entertainment, and more to ensure a smooth planning experience.'
            },
            {
                id: 3,
                heading: 'How involved will I be in the planning process?',
                content: 'We tailor our involvement based on your preferences. You can be fully engaged in each step or leave the logistics to us while we keep you updated on all decisions.'
            },
            {
                id: 4,
                heading: 'Can you help with last-minute changes or emergencies?',
                content: 'Absolutely. Our team is equipped to handle last-minute adjustments and resolve any unforeseen issues to ensure your event runs flawlessly.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Private Dining',
        content: 'Exclusive dining experiences curated for intimate celebrations and special moments.',
        paragraphs: [
            'Delight in an unforgettable culinary journey with our private dining services, designed for those seeking exclusivity and elegance. Whether it’s a romantic dinner, family gathering, or a small celebration, we provide a tailored atmosphere and gourmet cuisine to match the occasion.',
            'Our team creates a personalized setting with exceptional service, handcrafted menus, and a refined ambiance. Each detail—from menu customization to table décor—is thoughtfully arranged to elevate your private dining experience.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Exclusive Dining Settings',
            'Custom Menu Planning',
            'Elegant Décor and Ambiance',
            'Dedicated Chef and Staff',
            'Flexible Indoor or Outdoor Venues'
        ],
        procedure: [
            'Personalized Consultation and Theme Selection',
            'Menu Design and Taste Preferences',
            'Venue Setup and Atmosphere Styling',
            'On-Site Culinary Experience',
            'Clean-Up and Guest Follow-Up'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of events are suitable for private dining?',
                content: 'Private dining is ideal for birthdays, anniversaries, romantic evenings, family gatherings, and small celebrations where a personalized and intimate setting is preferred.'
            },
            {
                id: 2,
                heading: 'Can I customize the menu for my private dinner?',
                content: 'Yes, we offer fully customizable menus tailored to your tastes and dietary preferences. Our chefs work closely with you to design the perfect culinary experience.'
            },
            {
                id: 3,
                heading: 'Is the venue provided or can it be hosted at my location?',
                content: 'We offer both options. You can choose from our exclusive venues or we can bring the private dining experience to your chosen location—home, outdoor setting, or other.'
            },
            {
                id: 4,
                heading: 'Do you provide staff for private dining events?',
                content: 'Yes, we provide a dedicated team including chefs, servers, and event attendants to ensure flawless service throughout your private dining experience.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Menu Customization',
        content: 'Collaborate with our chefs to design a personalized menu tailored to your culinary preferences.',
        paragraphs: [
            'Create a dining experience that truly reflects your taste with our menu customization service. Whether you’re planning a special event, private dinner, or large celebration, our chefs work closely with you to design dishes that suit your style and dietary needs.',
            'From appetizers to desserts, every item on your menu can be tailored to include preferred ingredients, cultural flavors, and unique themes. We ensure your guests enjoy a memorable culinary journey that’s both meaningful and delicious.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Fully Customizable Menus',
            'Collaborative Menu Planning',
            'Diverse Cuisine Options',
            'Special Dietary Accommodations',
            'Creative and Seasonal Dishes'
        ],
        procedure: [
            'Initial Consultation and Preferences Discussion',
            'Chef Collaboration and Idea Exchange',
            'Tasting Session and Feedback',
            'Final Menu Design and Approval',
            'Culinary Execution on Event Day'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can I choose dishes from different cuisines?',
                content: 'Absolutely. We offer a wide range of global cuisines and can mix and match elements to create a fusion or multi-course experience that fits your theme.'
            },
            {
                id: 2,
                heading: 'Do you accommodate food allergies and dietary restrictions?',
                content: 'Yes, we carefully consider dietary restrictions and allergies during the menu planning process to ensure all guests have a safe and enjoyable experience.'
            },
            {
                id: 3,
                heading: 'Is there a tasting session before the event?',
                content: 'Yes, we arrange a tasting session where you can sample and refine your menu selections before final approval.'
            },
            {
                id: 4,
                heading: 'Can I update the menu after confirming?',
                content: 'Minor changes can usually be made up to a certain point before the event. We strive to remain flexible and accommodate your requests wherever possible.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Corporate Catering',
        content: 'Professional catering solutions designed to elevate your corporate events and impress every guest.',
        paragraphs: [
            'Make a lasting impression with our corporate catering services, tailored for business meetings, conferences, product launches, and more. We understand the importance of professionalism, punctuality, and presentation in the corporate world.',
            'Our menus are crafted with high-quality ingredients and can be customized to suit your brand or event theme. From boxed lunches to elegant buffets, our services are perfect for both formal and casual corporate gatherings.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'Customizable Corporate Menus',
            'On-Time Delivery and Setup',
            'Elegant Presentation and Display',
            'Dietary Options for Every Guest',
            'Experienced Staff and Coordination'
        ],
        procedure: [
            'Event Needs Assessment and Consultation',
            'Menu Planning Based on Event Type',
            'Scheduling and Logistics Coordination',
            'Efficient On-Site Setup and Service',
            'Post-Event Cleanup and Follow-Up'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of corporate events do you cater?',
                content: 'We cater to all corporate occasions including meetings, seminars, conferences, office parties, and formal receptions.'
            },
            {
                id: 2,
                heading: 'Do you offer individual meals for employees?',
                content: 'Yes, we offer individually packaged meals ideal for workplace lunches, training sessions, or safety-conscious gatherings.'
            },
            {
                id: 3,
                heading: 'Can the menu match our company branding?',
                content: 'Absolutely. We can align the menu style, presentation, and even packaging to reflect your brand identity and event tone.'
            },
            {
                id: 4,
                heading: 'Is staffing included in your corporate catering?',
                content: 'Yes, we provide experienced staff including servers, setup crew, and coordinators to ensure a smooth and professional service.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Special Occasions',
        content: 'Celebrate life’s most cherished moments with exceptional catering tailored to your unique occasion.',
        paragraphs: [
            'Whether it’s a milestone birthday, anniversary, baby shower, or engagement party, our catering services are designed to make your special occasion truly unforgettable. We bring creativity, flavor, and elegance to every celebration.',
            'Our team works closely with you to understand your vision and preferences, creating a personalized menu and experience that perfectly fits the tone and theme of your event. From intimate gatherings to grand celebrations, we ensure every detail is taken care of.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Tailored Menus for Every Celebration',
            'Stylish and Elegant Food Displays',
            'On-Site Staff and Coordinators',
            'Adaptable to Any Venue or Theme',
            'Options for Special Diets and Allergies'
        ],
        procedure: [
            'Event Consultation and Theme Discussion',
            'Menu Design with Personal Touches',
            'Planning Logistics and Staffing',
            'On-Site Setup and Dining Service',
            'Cleanup and Post-Event Support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of occasions do you cater?',
                content: 'We cater to a variety of personal events including birthdays, anniversaries, baby showers, engagements, and other memorable milestones.'
            },
            {
                id: 2,
                heading: 'Can the menu reflect a specific theme or cuisine?',
                content: 'Yes, we specialize in theme-based menu planning and can craft dishes inspired by different cultures, cuisines, or personal preferences.'
            },
            {
                id: 3,
                heading: 'Do you provide decorations and table settings?',
                content: 'While we focus primarily on catering, we can coordinate with decor vendors or offer simple table settings to match your event’s style.'
            },
            {
                id: 4,
                heading: 'Is your service available for outdoor events?',
                content: 'Yes, we cater both indoor and outdoor special occasions, ensuring a smooth and delicious experience regardless of the venue.'
            }
        ]
    }
];

export default services;